import Service from '../Service'
import AuthService from '../AuthService'

const ResearchForm = {
    saveResearchPage1(data) {
        let formData = new FormData();
        formData.append('thResearchName',data.researchs.thResearchName);
        formData.append('enResearchName',data.researchs.enResearchName);
        formData.append('field',data.researchs.field);
        formData.append('startDate',data.researchs.startDate);
        formData.append('endDate',data.researchs.endDate);
        formData.append('researchPlace',data.researchs.researchPlace);
        formData.append('affiliationBookFile',data.researchs.affiliationBookFile);
        formData.append('researchInfoFile',data.researchs.researchInfoFile);
        // formData.append('researcherTypeID',data.researchs.researcherTypeID);
        formData.append('amountOfVolunteer',data.researchs.amountOfVolunteer);
        formData.append('researchID',data.researchID);
        formData.append('researcher', JSON.stringify(data.researchers));
        formData.append('research_info',JSON.stringify(data.researcher_info));
        formData.append('_method', 'POST');
        for(let pair of formData.entries()) {
            // console.log(pair[0]+ ', '+ pair[1]);
        }
        return AuthService.post('/api/add-research', formData,{
            headers: {
                "Content-Type": 'multipart/form-data',
            }
        }).then(res => res)
    },
    editResearch(data) {
        // console.log('Research 2' ,data);
        // console.log('Research id' ,id);
        return AuthService.post(`/api/edit-research/${data.researchID}`, data.researchs).then(res => res)
    },
    deleteResearch(id) {
        return AuthService.delete(`/api/delete-research/${id}`).then(res => res)
    },

    saveResearchPage2(data,id) {
        // console.log('Research 2' ,data);
        // console.log('Research id' ,id);
        return AuthService.post(`/api/add-research-page3-4/${id}`, data).then(res => res)
    },

    saveResearchPage3(data,id) {
        // console.log('Research 3' ,data);
        // console.log('Research id' ,id)
        return AuthService.post(`/api/add-research-page3-4/${id}`, data).then(res => res)
    },

    saveResearchPage4(data,id) {
        // console.log('Research 4' ,data);
        // console.log('Research id' ,id)
        let formData = new FormData();
        formData.append('reference',data.reference);
        formData.append('related_documents',data.related_documents);
        formData.append('data_collection_form',data.data_collection_form);
        formData.append('history',data.history);
        formData.append('other',data.other);
        formData.append('_method', 'POST');
        return AuthService.post(`/api/add-research-page5/${id}`, formData,{
            headers: {
                "Content-Type": 'multipart/form-data',
            }
        }).then(res => res)
    },

    getFormResearch1(id) {
        return AuthService.get(`/api/show-research/${id}`).then(res => res)
    },

    getFormResearch2(id) {
        return AuthService.get(`/api/show-research/${id}`).then(res => res)
    },

    getFormResearch3(id) {
        return AuthService.get(`/api/show-research/${id}`).then(res => res)
    },

    getFormResearch4(id) {
        return AuthService.get(`/api/show-research/${id}`).then(res => res)
    },
}

export default ResearchForm;
